<template>
  <div>
    <v-dialog v-model="dialog" persistent transition="dialog-top-transition" max-width="600">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="botao_1"
          class="mt-5"
          v-bind="attrs"
          v-on="on"
          small
          text
        >Esqueceu a senha?</v-btn>
      </template>

      <v-stepper v-model="e1" class="rounded-lg">
        <!-- Titulo -->
        <h2 class="text-center display-1 py-4 primary white--text">
          ESQUECEU SUA SENHA?
        </h2>
        <!-- /Titulo -->

        <!-- Subtitulo -->
        <h4 class="text-center py-2 secondary white--text">
          Preencha os formulários para alterar sua senha
        </h4>
        <!-- /Subtitulo -->

        <!-- Etapas -->
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">
            E-mail cadastrado
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2" step="2">
            Código de validação
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3">
            Nova senha
          </v-stepper-step>
        </v-stepper-header>
        <!-- /Etapas -->

        <!-- Conteudos -->
        <v-stepper-items>
          <v-stepper-content step="1">
            <EmailCadastrado
              @form-submit="email_enviado"
              @cancelar="dialog=false"
            ></EmailCadastrado>
          </v-stepper-content>

          <v-stepper-content step="2">
            <CodigoValidacao
              :email="email"
              @form-submit="codigo_validado"
              @cancelar="dialog=false"
            ></CodigoValidacao>
          </v-stepper-content>

          <v-stepper-content step="3">
            <NovaSenha
              :email="email"
              @fazer-login="senha_alterada()"
              @cancelar="dialog=false"
            ></NovaSenha>
          </v-stepper-content>
        </v-stepper-items>
        <!-- /Conteudos -->
      </v-stepper>
    </v-dialog>
  </div>
</template>

<script>
import EmailCadastrado from "./components/EmailCadastrado"
import CodigoValidacao from "./components/CodigoValidacao";
import NovaSenha from "./components/NovaSenha";

export default {
  name: "EsqueciMinhaSenhaView",

  components: {
    EmailCadastrado,
    CodigoValidacao,
    NovaSenha,
  },

  data: () => ({
    e1: 1,
    dialog: false,
    email: "",
  }),

  methods: {
    email_enviado(email) {
      this.email = email;
      this.e1 = 2;
    },

    codigo_validado() {
      this.e1 = 3;
    },

    senha_alterada() {
      this.e1=1;
      this.dialog=false;
    },
  },
};
</script>
  